import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  paper: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    minHeight: theme.spacing(6),
  },
  title: {
    flex: 1,
    minWidth: 0,
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    textAlign: 'inherit',
    paddingLeft: theme.spacing(1),
  },
  paperWrapper: {
    padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
  },
  // @todo: add extend jss plugin
  selectedPaper: {
    padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
    backgroundColor: theme.palette.primary.light,
  },
  buttonPaper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    cursor: 'pointer',
    backgroundColor: theme.palette.primary.light,
    color: 'white !important',
  },
  auto: {
    padding: 12,
  },
}));
